import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import actions from './redux/actions/user';
import Layout from './component/sidebar/Layout';
import messages from './langs/messages';
import './styles/App.scss';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import LoginPageContainer from './containers/LoginPageContainer';
import NeedInitComponent from './common/NeedInitComponent';

function App(props) {
  const [locale, setLocale] = useState('en');

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {props.user.isAuthenticated ? (
        <NeedInitComponent>
          {' '}
          <Layout setLocale={setLocale} />
          {' '}
        </NeedInitComponent>
      ) : <LoginPageContainer />}
    </IntlProvider>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  logout(params) {
    dispatch(actions.logout(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
